import React from 'react';
import SummaryDetailBar from './components/SummaryDetailBar';
import { isEmpty } from 'lodash';
import PerformanceCardSkeleton from '../../components/PerformanceCardSkeleton';

const SummaryTab = (props) => {
  const {
    colStyle,
    selectedCampaign,
    chartsLoading,
    campaignOrder,
    chartData,
    showTransactions,
    showAttribution,
    bySummaryRangeDate,
    setBySummaryRangeDate,
    dataSummaryRangeDate,
    setDataSummaryRangeDate,
    signUpCampaign,
    setRangeType,
    rangeType,
    priceVisible,
    currentUser,
    showSessions,
  } = props;
  if (chartsLoading) return <PerformanceCardSkeleton />;

  return (
    <SummaryDetailBar
      colStyle={colStyle}
      selectedCampaign={selectedCampaign}
      campaignOrder={campaignOrder}
      chartData={chartData}
      signUpCampaign={signUpCampaign}
      showTransactions={showTransactions}
      showAttribution={showAttribution}
      bySummaryRangeDate={bySummaryRangeDate}
      setBySummaryRangeDate={setBySummaryRangeDate}
      dataSummaryRangeDate={dataSummaryRangeDate}
      setDataSummaryRangeDate={setDataSummaryRangeDate}
      setRangeType={setRangeType}
      rangeType={rangeType}
      priceVisible={priceVisible}
      ShowSessions={showSessions}
      dataConfig={!isEmpty(currentUser.role.org) ? currentUser.role.org.dataConfig : {}}
      {...props}
    />
  );
};

export default SummaryTab;
